import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTriangleExclamation,
  faCircleExclamation
} from '@fortawesome/free-solid-svg-icons';
import { SEVERITY, worstSeverity } from '../../helpers/launchChecks';

/**
 * One small icon, shown only when something about a planned execution deserves a
 * second look. Nothing at all when everything is fine.
 *
 * Deliberately the smallest possible footprint: the wizard is already dense, and
 * an advisory that takes up permanent space stops being read. The detail lives
 * in the tooltip, so the row gains a single character's width and nothing else.
 */
const LaunchWarning = ({ warnings = [], className = '', placement = 'top' }) => {
  const severity = worstSeverity(warnings);
  if (!severity) return null;

  const blocking = severity === SEVERITY.BLOCKING;

  return (
    <OverlayTrigger
      placement={placement}
      overlay={
        <Tooltip id={`launch-warning-${warnings[0]?.message?.slice(0, 12)}`}>
          <div className="text-start">
            {warnings.map((w, i) => (
              <div key={i} className={i ? 'mt-2' : ''}>
                {w.message}
              </div>
            ))}
          </div>
        </Tooltip>
      }
    >
      <span
        className={`d-inline-flex align-items-center ${className}`}
        style={{ cursor: 'help' }}
      >
        <FontAwesomeIcon
          icon={blocking ? faCircleExclamation : faTriangleExclamation}
          className={blocking ? 'text-danger' : 'text-warning'}
        />
      </span>
    </OverlayTrigger>
  );
};

export default LaunchWarning;
